import './BarsLoader.scss'

export const BarsLoader = () => {
  return (
    <div className="bars-loader">
      <img src='/images/loader2.gif' alt="loading gif"/>
    </div>
  )
}
